export const gitCommit = 'a09c6f9d'
